import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IDeleteMySavedPasswordsAndCredentialsParams {
}

export interface IDeleteMySavedPasswordsAndCredentialsResult extends IResult {
}

export class DeleteMySavedPasswordsAndCredentialsRequest
  extends Request<IDeleteMySavedPasswordsAndCredentialsParams, IDeleteMySavedPasswordsAndCredentialsResult> {

  constructor(params: IDeleteMySavedPasswordsAndCredentialsParams = {}) {
    super('deleteMySavedPasswordsAndCredentials', params);
  }
}
